import React from 'react';

export default function ButtonContainer({
  children,
  className = '',
  ...props
}) {
  return (
    <div
      className={`tablet:flex-row flex flex-col items-center justify-center gap-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
